import Title from "../components/Title";
import Subtitle from "../components/Subtitle";
import Button from "../components/Button";

import prizeFreeBlock from "../assets/icons/your-prize-free-block.svg";
import prizeFreeInner from "../assets/icons/your-prize-free-inner.png";

import discountBlock from "../assets/icons/your-prize-discount-block.svg";
import discountInner from "../assets/icons/your-prize-discount-inner.png";

import failBlock from "../assets/icons/your-prize-nothing-block.svg";
import failInner from "../assets/icons/your-prize-nothing-inner.png";

import starRed from "../assets/images/decors/star-red.svg";
import starGreen from "../assets/images/decors/star-green.svg";
import starBlue from "../assets/images/decors/star-blue.svg";

const WinScreen = ({ type }) => {
  let title, subtitle, btnTxt, color, btnColor, txtColor, decorColor;

  if (type === "free") {
    title = "Ты сделал это!";
    subtitle =
      "Ты выиграл! Теперь твой приз можно обменять на отрисовку любого банка. Жми на кнопку ниже и выбирай!";
    btnTxt = "Обменять";
    color = "green";
  } else if (type === "discount") {
    title = "Скидка твоя!";
    subtitle =
      "Скидка в 50% готова к использованию. Теперь можно обменять её на отрисовку любого банка. Жми на кнопку ниже и выбирай!";
    btnTxt = "Обменять";
    color = "blue";
    decorColor = "blue";
  } else if (type === "failed") {
    title = "Почти получилось!";
    subtitle = "Не сдавайся, удача любит настойчивых. Возвращайся завтра и попробуй еще раз!";
    btnTxt = "Хорошо";
    color = "red";
    btnColor = "red";
    txtColor = "red";
    decorColor = "red";
  }

  return (
    <main className="relative z-10 bg-main flex items-center justify-center bg-cover bg-center min-h-screen w-full overflow-hidden">
      <div
        className={`absolute inset-0 ${
          color === "red" ? "bg-bgRed" : color === "blue" ? "bg-bgBlue" : "bg-bgGreen"
        } backdrop-blur-md shadow-lg flex justify-center items-center z-[-2]`}
      >
        <div
          className={`absolute h-[300px] w-[500px] top-[-10%] left-1/2 ${
            decorColor === "red" ? "bg-red" : decorColor === "blue" ? "bg-blue" : "bg-green"
          } bg-[rgba(102,35,35,0.8)] rounded-full blur-[200px] z-[-1] transform -translate-x-1/2 -translate-y-1/2`}
        ></div>
      </div>

      {/* Декоративные звёзды */}

      <div className="absolute -z-[1] mobile:-left-14 desktop:left-24 mobile:top-4 small:top-4 desktop:top-24 animate-pulse">
        <img
          className="h-14 w-56"
          src={decorColor === "red" ? starRed : decorColor === "blue" ? starBlue : starGreen}
          alt="Процент"
        />
      </div>

      <div className="absolute -z-[1] mobile:-left-28 desktop:-left-8 animate-pulse">
        <img
          src={decorColor === "red" ? starRed : decorColor === "blue" ? starBlue : starGreen}
          alt="Процент"
        />
      </div>

      <div className="absolute -z-[1] left-24 mobile:bottom-4 desktop:top-2/3 animate-pulse">
        <img
          className="h-14 w-56"
          src={decorColor === "red" ? starRed : decorColor === "blue" ? starBlue : starGreen}
          alt="Процент"
        />
      </div>

      <div className="absolute -z-[1] mobile:-right-14 desktop:right-12 top-24 animate-pulse">
        <img
          className="h-14 w-56"
          src={decorColor === "red" ? starRed : decorColor === "blue" ? starBlue : starGreen}
          alt="Процент"
        />
      </div>

      <div className="absolute -z-[1] mobile:-right-28 desktop:-right-8 mobile:top-2/3 desktop:top-1/3 animate-pulse">
        <img
          src={decorColor === "red" ? starRed : decorColor === "blue" ? starBlue : starGreen}
          alt="Процент"
        />
      </div>

      <div className="absolute -z-[1] right-24 mobile:-bottom-3/4 desktop:top-3/4 animate-pulse">
        <img
          className="h-14 w-56"
          src={decorColor === "red" ? starRed : decorColor === "blue" ? starBlue : starGreen}
          alt="Процент"
        />
      </div>

      {/* Контент */}

      <section className="win">
        <div className="mb-4">
          <Title text={title} />
        </div>
        <div className="flex justify-center min-w-full max-w-[28rem] mb-12">
          <Subtitle text={subtitle} color={txtColor} />
        </div>
        <div className="flex justify-center mb-12 ">
          <div
            className={`absolute h-48 w-48 ${
              decorColor === "red" ? "bg-red" : decorColor === "blue" ? "bg-blue" : "bg-green"
            } ${txtColor} opacity-50 blur-3xl rounded-full z-[-1] animate-ping`}
          ></div>

          {type === "free" && (
            <div className="relative">
              <img className="mobile:w-36 desktop:w-52 z-[2]" src={prizeFreeBlock} alt="" />
              <img
                className="mobile:w-36 desktop:w-52 absolute top-5 desktop:top-7"
                src={prizeFreeInner}
                alt=""
              />
            </div>
          )}
          {type === "discount" && (
            <div className="relative">
              <img className="mobile:w-36 desktop:w-52 z-[2]" src={discountBlock} alt="" />
              <img
                className="mobile:w-28 desktop:w-52 left-[50%] translate-x-[-50%] absolute bottom-4 max-w-[80%]"
                src={discountInner}
                alt=""
              />
            </div>
          )}
          {type === "failed" && (
            <div className="relative mobile:w-36 desktop:w-52">
              <img className="mobile:w-36 desktop:w-52 z-[2]" src={failBlock} alt="" />
              <img
                className="mobile:w-37 desktop:w-53 left-[50%] translate-x-[-50%] absolute top-4 max-w-[115%] desktop:top-7"
                src={failInner}
                alt=""
              />
            </div>
          )}
        </div>
        <div className="flex justify-center">
          <Button color={btnColor} text={btnTxt} onClick={() => window.location.reload()} />
        </div>
      </section>
    </main>
  );
};

export default WinScreen;
